import { render, staticRenderFns } from "./solicitud3.vue?vue&type=template&id=1bf1aa1c&"
import script from "./solicitud3.vue?vue&type=script&lang=js&"
export * from "./solicitud3.vue?vue&type=script&lang=js&"
import style0 from "./solicitud3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports